@if (loading()) {
	<div class="code-input__loader">
		<tui-loader [size]="size()" [inheritColor]="true" />
	</div>
}
@for (char of codeArray(); track $index) {
	<input
		tuiAutoFocus
		#inputRef
		class="code-input__box"
		[class.code-input__box--empty]="!char"
		type="text"
		[value]="char"
		[maxLength]="1"
		[disabled]="disabled()"
		(input)="onInput($index, $event)"
		(keydown)="onKeyDown($index, $event)"
		(focus)="onFocus($index)"
		(paste)="onPaste($event)"
		autocomplete="off"
		autocapitalize="off"
		autocorrect="off"
		spellcheck="false"
	/>
}
